import dynamicsLogoBlack from '../../../../assets/avif_icons/dynamics_365_logo_black.avif';

const DynamicsLogo = () => {
  //   const isDarkMode = document.documentElement.classList.contains("dark");
  const logoSrc = dynamicsLogoBlack;

  return <img className="w-40 h-30" src={logoSrc} alt="Dynamics Logo" />;
};

export default DynamicsLogo;
